import Swiper from 'swiper'

export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        function init(element: HTMLElement) {
            const sliderEl = element

            if (!sliderEl) return
            new Swiper(sliderEl, {
                spaceBetween: '16px',
                slidesPerView: 1.3,
                speed: 500,
                breakpoints: {
                    640: {
                        slidesPerView: 2.3,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: '24px',
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: '24px',
                    },
                },
            })
        }

        const elements = document.querySelectorAll<HTMLElement>('[data-news-slider]')

        if (elements.length > 0)
            elements.forEach((element) => {
                    if (element instanceof HTMLElement)
                        init(element)
                }
            )

    })
}
